import { type JSX, Show, Suspense } from "solid-js";
import { CategoryTree } from "@/components/CategoryTree";
import { OnlineUsers } from "@/components/OnlineUsers";
import { Accordion, AccordionItem, Button, Skeleton, Stack } from "@/components/ui";
import { categories } from "@/state/categories";
import { isAdmin } from "@/state/me";

/**
 * カテゴリ・オンライン一覧。広い画面では左に置き、狭い画面ではメニューの中に入る。
 *
 * `collapsed` はメニューの中で使う。開く前から一覧を全部出すと縦に長くなるので、
 * 移動したいときだけ開いてもらう。
 */
export function SideNav(props: {
  collapsed?: boolean;
  onNavigate?: () => void;
  onAddCategory: () => void;
}): JSX.Element {
  const tree = (
    <Suspense fallback={<Skeleton height="8rem" />}>
      <Show when={categories()}>{(list) => <CategoryTree categories={list()} />}</Show>
    </Suspense>
  );

  /** 移動したときだけ閉じる。アコーディオンの開閉で閉じては困る。 */
  const closeIfNavigated = (event: MouseEvent) => {
    const target = event.target;
    if (target instanceof Element && target.closest("a") !== null) props.onNavigate?.();
  };

  return (
    <Stack gap={3} class="side-nav" onClick={closeIfNavigated}>
      <Show when={props.collapsed === true} fallback={tree}>
        <Accordion>
          <AccordionItem title="カテゴリ">{tree}</AccordionItem>
        </Accordion>
      </Show>
      <OnlineUsers />
      <Show when={isAdmin()}>
        <Button variant="ghost" size="sm" onClick={() => props.onAddCategory()}>
          カテゴリを追加
        </Button>
      </Show>
    </Stack>
  );
}
